"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var Spinner_component_1 = require("@greatmindsorg/atomic-ui-lib-lts/dist/components/atoms/Spinner/Spinner.component");
var Spinner_styled_1 = require("./Spinner.styled");
/**
 * Spinner component uses Atomic Spinner and add css to align it to the center of parent
 */
var Spinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? Spinner_component_1.SpinnerSize.large : _b, ariaLabel = _a.ariaLabel, _c = _a.className, className = _c === void 0 ? '' : _c;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    return ((0, jsx_runtime_1.jsx)(Spinner_styled_1.StyledSpinner, { className: className, children: (0, jsx_runtime_1.jsx)(Spinner_component_1.Spinner, { size: size, ariaLabel: ariaLabel || t('loading') }) }));
};
exports.Spinner = Spinner;
